// Console SPA — 简易 hash 路由（取代 TanStack Router）。

import { useEffect, useState } from 'react';

export type RouteName =
  | 'login'
  | 'register'
  | 'oauth_success'
  | 'sites'
  | 'dashboard'
  | 'logs';

const ROUTES: Record<string, RouteName> = {
  '#/login': 'login',
  '#/register': 'register',
  '#/oauth/success': 'oauth_success',
  '#/sites': 'sites',
  '#/dashboard': 'dashboard',
  '#/logs': 'logs',
};

function parseHash(): RouteName {
  const h = (typeof window === 'undefined' ? '' : window.location.hash) || '#/sites';
  // 路由可能携带查询参数（如 #/oauth/success?token=xxx）
  const path = h.split('?')[0] ?? h;
  return ROUTES[path] ?? 'sites';
}

export function useHashRoute(): RouteName {
  const [route, setRoute] = useState<RouteName>(parseHash);
  useEffect(() => {
    const onChange = (): void => setRoute(parseHash());
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);
  return route;
}

export function navigate(name: RouteName): void {
  // 'oauth_success' 是带 query 的特殊路由，外部直接 location.hash 设
  if (name === 'oauth_success') {
    window.location.hash = '#/oauth/success';
  } else {
    window.location.hash = `#/${name}`;
  }
}

/** 解析 URL hash 中的 query string（例如 #/oauth/success?token=xxx）。 */
export function parseHashQuery(): URLSearchParams {
  if (typeof window === 'undefined') return new URLSearchParams();
  const h = window.location.hash;
  const idx = h.indexOf('?');
  if (idx < 0) return new URLSearchParams();
  return new URLSearchParams(h.slice(idx + 1));
}
